import { render } from "./HeaderGlobal.vue?vue&type=template&id=1c89b59c"
import script from "./HeaderGlobal.vue?vue&type=script&lang=js"
export * from "./HeaderGlobal.vue?vue&type=script&lang=js"

import "./HeaderGlobal.vue?vue&type=style&index=0&id=1c89b59c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__